import { Grid } from "@mui/material";
import { Field, Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import { Base } from "../base";
import { Inputs } from "../formInputs";
import { useSelector } from "../../store";

interface Props {
  handleDelete: () => void;
  handleCancel: () => void;
}

const ConfirmDeleteForm: React.FC<Props> = (props) => {
  const { handleDelete, handleCancel } = props;
  const { status, job } = useSelector((store) => store.job);
  const { currentViewJobType } = useSelector((store) => store.jobType);

  const validationSchema = Yup.object().shape({
    confirm: Yup.string()
      .required("Type 'delete' to confirm")
      .typeError("Type 'delete' to confirm"),
  });

  return (
    <Formik
      initialValues={{ confirm: "" }}
      onSubmit={handleDelete}
      validationSchema={validationSchema}
    >
      {({ values }) => (
        <Form noValidate>
          <Grid container>
            <Grid
              sx={{
                padding: "10px",
              }}
            >
              <Base.Text
                text={`Are you sure you want to delete this ${currentViewJobType?.name}?`}
                center
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Field
                name="confirm"
                label="Type 'delete' to confirm"
                component={Inputs.Text}
                required
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Grid container justifyContent={"space-around"}>
                <Grid>
                  <Base.Button text="Cancel" onClick={handleCancel} />
                </Grid>
                <Grid>
                  <Inputs.Submit
                    text="Delete"
                    isSubmitting={status === "loading"}
                    disabled={values.confirm.toLowerCase() !== "delete"}
                    type="delete"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ConfirmDeleteForm;
